import store from "@/store";
import request from "@/utils/extRequest";

//관리자목록
export async function getTextbookAtrbRelInfoList(params) {
    console.log("@@ get list : getTextbookAtrbRelInfoList");
    let result = request.get("/api/ext/textbookAtrbRelInfo/",{params});
    return result;
}

export async function getTextbookAtrbRelInfoItem(params) {
    console.log("@@ get item : getTextbookAtrbRelInfoItem");
    let result = request.get(`/api/ext/textbookAtrbRelInfo/${params.textbookId}`,{params} );
    return result;
}

export async function saveTextbookAtrbRelInfo(params) {
    console.log("@@ post save : saveTextbookAtrbRelInfo");
    let result = request.post(`/api/ext/textbookAtrbRelInfo/`,params);
    return result;
}

export async function deleteTextbookAtrbRelInfo(params) {
    console.log("@@ delete : deleteTextbookAtrbRelInfo");
    let result = request.delete(`/api/ext/textbookAtrbRelInfo/${params.textbookId}`,{params});
    return result;
}
